/* eslint-disable react/jsx-props-no-spreading */
import React, { useState } from "react";
import { Upload, message } from "antd";
import type { UploadProps } from "antd";
import { UploadFile } from "antd/lib/upload/interface";
import upload from "../../img/upload.png";
import { uploadFileTypes } from "../../lib/const/uploadFileTypes";

type AcceptFileType = keyof typeof uploadFileTypes;

interface DropzoneProps {
  updateFile: (file: UploadFile | null) => void;
  disabled?: boolean;
  accept?: AcceptFileType[];
}

const Dropzone = (props: DropzoneProps) => {
  const { updateFile, disabled, accept = ["txt", "csv"] } = props;
  const [files, setFiles] = useState<UploadFile[]>([]);

  const fakeRequest: UploadProps["customRequest"] = ({ onSuccess }) => {
    if (onSuccess) {
      setTimeout(() => onSuccess("ok", new XMLHttpRequest()), 0);
    }
  };

  const onChange: UploadProps["onChange"] = ({ file }) => {
    const { status, name } = file;
    const fileType = name.split(".").reverse()[0] as AcceptFileType;

    if (status === "error") {
      message.destroy();
      message.error(`Загрузка файла ${file.name} не удалась`);
    } else if (!accept.includes(fileType)) {
      message.destroy();
      setFiles([]);
      updateFile(null);
      message.error("Неверный формат загруженного файла");
    } else {
      setFiles([file]);
      updateFile(file);
    }
  };

  const onRemove = () => {
    setFiles([]);
    updateFile(null);
    message.info("Файл удален");
    return false;
  };

  const uploadAccept = accept.map((item) => uploadFileTypes[item]).join(", ");

  return (
    <Upload.Dragger
      className="dropzone"
      name="file"
      multiple={false}
      accept={uploadAccept}
      fileList={files}
      onChange={onChange}
      onRemove={onRemove}
      customRequest={fakeRequest}
      disabled={disabled}
    >
      <p className="ant-upload-drag-icon">
        <img src={upload} alt="Загрузка файла" />
      </p>
      <p className="ant-upload-text">Перетащите документы сюда или кликните, чтобы выбрать файл</p>
    </Upload.Dragger>
  );
};

export default Dropzone;
